'use strict';

import storage from './storage';
import Mustache from 'mustache';

let buyingOptionsBar: BuyingOptionsBar = {

  buyingOptions: null,
  tyreData: null,
  selectedSize: null,
  selectedVehicle: null,
  foundSizes: [],
  buyingOptionsBar: null,
  buyingOptionsPopover: null,
  buyingOptionsVehicle: null,
  buyingOptionsTyreSize: null,
  buyingOptionsToggler: null,
  buyingOptionsIconToggler: null,
  tyreOptionsContainer: null,
  tyreOptionsTemplate: '',
  tyreselectorLink: null,
  buyingOptionsOpen: '',
  buyingOptionsClose: '',

  /**
   * Send analytics event.
   *
   * @param {string} type - Event type.
   * @param {object} data - Additional event data.
   */
  sendAnalyticsEvent(type, data = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: type,
      tyreSize: this.buyingOptionsTyreSize?.textContent || '',
      productCode: (this.tyreOptionsContainer?.querySelector('[data-tyre-option-select]') as HTMLSelectElement)?.value || '',
      ...data,
    });
  },

  toggleBuyingOptions(show, sendEvent = false) {
    let shouldHide = (typeof show === 'boolean' ? !show : this.buyingOptionsBar?.classList.contains('opened'));
    if (shouldHide) {
      // hide
      this.buyingOptionsToggler?.classList.remove('opened');
      this.buyingOptionsBar?.classList.remove('opened');
      if (this.buyingOptionsPopover) this.buyingOptionsPopover.style.display = 'none';
      if (this.buyingOptionsToggler) this.buyingOptionsToggler.textContent = this.buyingOptionsOpen;
      // Store that user has once closed the buiyng options so we do not open it on page load
      if (storage.local) {
        localStorage.setItem('buyingOtionsOnceClosed', 'true');
      }
      if (sendEvent) {
        this.sendAnalyticsEvent('quickBuyClose');
      }
      this.buyingOptionsToggler?.setAttribute('aria-expanded', 'false');
      this.buyingOptionsToggler?.focus();
      return false;
    } else {
      // show
      this.buyingOptionsToggler?.classList.add('opened');
      this.buyingOptionsBar?.classList.add('opened');
      if (this.buyingOptionsPopover) this.buyingOptionsPopover.style.display = 'block';
      if (this.buyingOptionsToggler) this.buyingOptionsToggler.textContent = this.buyingOptionsClose;
      if (sendEvent) {
        this.sendAnalyticsEvent('quickBuyOpen');
      }
      this.buyingOptionsToggler?.setAttribute('aria-expanded', 'true');
      return true;
    }
  },

  updatePopoverContentAndActions() {
    let self = this;

    if (this.buyingOptionsVehicle) this.buyingOptionsVehicle.style.display = "none";
    if (this.buyingOptionsTyreSize) this.buyingOptionsTyreSize.style.display = "none";

    if (!this.foundSizes.length) {
      return;
    }

    if (this.selectedVehicle) {
      let vehicleInfo = (this.selectedVehicle.license ? this.selectedVehicle.license + ', ' : '') + this.selectedVehicle.manufacturer + ' ' + this.selectedVehicle.model + ' ' + this.selectedVehicle.year;
      if (this.buyingOptionsVehicle) this.buyingOptionsVehicle.textContent = vehicleInfo;
      if (this.buyingOptionsVehicle) this.buyingOptionsVehicle.style.display = "block";
    }

    if (this.selectedSize) {
      let tyreSizeInfo = this.selectedSize.width + '/' + this.selectedSize.height + 'R' + this.selectedSize.rim;
      if (this.buyingOptionsTyreSize) this.buyingOptionsTyreSize.textContent = tyreSizeInfo;
      if (this.buyingOptionsTyreSize) this.buyingOptionsTyreSize.style.display = "block";
      if (this.tyreOptionsTemplate) {
        if (this.tyreOptionsContainer) this.tyreOptionsContainer.innerHTML = Mustache.render(this.tyreOptionsTemplate, this.foundSizes);
      }

      // Initialize tyre options select
      const select = this.tyreOptionsContainer?.querySelector('[data-tyre-option-select]');
      const changeSize = (el) => {
        let sizeId = el.value;

        let options = self.tyreOptionsContainer?.querySelectorAll('[data-tyre-size-id]');
        if (options) options.forEach(o => (o as HTMLElement).style.display = "none");
        const size = self.tyreOptionsContainer?.querySelector('[data-tyre-size-id="' + sizeId + '"]');
        if (size) (size as HTMLElement).style.display = "block";
      };
      select?.addEventListener('change', function () {
        changeSize(select);
        self.sendAnalyticsEvent('quickBuyDropdown');
      });
      changeSize(select);

      // Register dealer/hatch button events
      this.tyreOptionsContainer?.querySelector('[data-gtm-button]')?.addEventListener('click', function (evt) {
        const btn = evt.target as HTMLElement;
        if (btn) {

          self.sendAnalyticsEvent(btn.dataset.gtmButton || '');
          // Prevent default action so events have a bit of time to get sent
          const isLink = btn.tagName === 'A' && (btn.getAttribute('href') || '').indexOf('#') !== 0;
          if (isLink) {
            evt.preventDefault();

            setTimeout(() => {
              if (btn.getAttribute('href') !== null) window.location = btn.getAttribute('href') as unknown as Location;
            }, 500);
          }
        }
      });
    }
    return;
  },

  /**
   * Stores product data to sessionStorage.
   *
   * @param {object} data Data to store.
   */
  storeBuyingOptions(data) {
    try {
      const dataToStore = { ...data };
      dataToStore.sizes = data.sizes.map(item => {
        // Unminimize properties
        const { w, h, r, li, sr, info, ...extra } = item;
        return {
          width: w,
          height: h,
          rim: r,
          loadIndex: li,
          speedRating: sr,
          productInfo: info,
          ...extra,
        };
      });
      console.log('Found buying options', dataToStore);
      window.sessionStorage.setItem('buyingOptions', JSON.stringify(dataToStore));
    }
    catch (e) {
      console.error(e);
    }
  },

  /**
   * Load buying options from sessionStorage and populate instance variables with loaded data.
   */
  loadBuyingOptions() {
    try {
      // Load buying options
      const sessionOptionsData = window.sessionStorage.getItem('buyingOptions');
      const buyingOptions = sessionOptionsData ? JSON.parse(sessionOptionsData) : null;

      if (!buyingOptions) {
        return;
      }
      this.buyingOptions = buyingOptions;

      // Get tyre data
      const tyreData = this.tyreData;
      if (!tyreData) {
        return;
      }


      // Remove tyre sizes that do not match selected size
      this.buyingOptions.sizes = buyingOptions.sizes.filter(item => {
        return item.width === tyreData.width && item.height === tyreData.height && item.rim === tyreData.rim;
      });

      this.foundSizes = this.buyingOptions.sizes;
    }
    catch (e) {
      console.error(e);
    }
  },

  getSelectedTyreData() {
    // tyreData is created by tyreselector
    // {"width":245,"height":40,"rim":18,"tsViewNavItem":"#filterLicense","license":{"text":"CGG-964","country":"FI","data":{"id":"17293","manufacturer":"BMW","model":"5-Serie (E60/E61)","year":"2004","kw":"141","hp":"192","tyres":{"245/45R17":false,"245/40R18":true,"245/35R19":false,"225/55R16":false,"225/50R17":false},"wheels":{"245/45R17":{"8x17/20":false},"245/40R18":{"8x18/20":true},"245/35R19":{"8x19/20":false},"225/55R16":{"7x16/20":false},"225/50R17":{"7.5x17/20":false}},"pcd":"5x120","offset":"20","center_bore":"72.6","sorted":["225/55R16","225/50R17","245/45R17","245/40R18","245/35R19"]}},"tsViews":"hidden"}

    // reset
    this.tyreData = null;
    this.selectedSize = null;
    this.selectedVehicle = null;

    // do we have HTML5 storage support?
    if (storage.session) {
      let storedData = sessionStorage.getItem('tyreData') || localStorage.getItem('tyreData');

      try {
        let tyreData: TyreData = JSON.parse(storedData || '');

        if (tyreData) {

          // set selected size only if tyreData has width, height and rim
          if (tyreData.width && tyreData.height && tyreData.rim) {
            this.selectedSize = {
              width: tyreData.width,
              height: tyreData.height,
              rim: tyreData.rim,
            };
          }

          // Vehicle info, if exists, could be in tyreData object root or in tyreData.license.data
          if (tyreData.manufacturer && tyreData.model && tyreData.year) {
            this.selectedVehicle = {
              license: null,
              manufacturer: tyreData.manufacturer.text,
              model: tyreData.model.text,
              year: tyreData.year.text,
            };
          } else if (tyreData.license && tyreData.license.text && tyreData.license.data && tyreData.license.data.manufacturer && tyreData.license.data.model && tyreData.license.data.year) {
            this.selectedVehicle = {
              license: tyreData.license.text,
              manufacturer: tyreData.license.data.manufacturer,
              model: tyreData.license.data.model,
              year: tyreData.license.data.year,
            };
          }
        }

        if (this.selectedSize) {
          this.tyreData = tyreData;
        }
      } catch (e) {
        //
      }
    }
  },

  updateFoundSizes() {
    let self = this;
    this.foundSizes = [];
    if (self.selectedSize && window.buyingOptionsTyreSizes) {
      window.buyingOptionsTyreSizes.forEach((size) => {
        if (size.width === self.selectedSize.width && size.height === self.selectedSize.height && size.rim === self.selectedSize.rim) {
          self.foundSizes.push(size);
        }
      });
    }
  },

  scrollToTyreselector() {
    let self = this;
    let tyreselector = document.querySelector('#tyreselector_4');
    if (tyreselector) {
      tyreselector.scrollIntoView({ behavior: 'smooth' });
      self.toggleBuyingOptions(false);

      let tyreselectorToggler = tyreselector.querySelector('a.toggler');
      // Open tyreselector if it's closed (by checking .tsViews visibility)
      if (tyreselectorToggler && !tyreselectorToggler.classList.contains('closed')) {
        (tyreselectorToggler as HTMLButtonElement).click();
      }

      return true;
    }
    return false;
  },

  /**
  * Check for escape to close menu
  */
  onDocumentKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Escape') {
      return;
    }

    // Only trigger if buying options bar is open
    if (this.buyingOptionsBar?.classList.contains('opened')) {
      this.toggleBuyingOptions(false);
    }
  },

  // =========================================
  // INIT FUNCTION
  // =========================================

  init: function () {
    console.log('buyingOptionsBar.init()');

    var self = this;

    // Store PIH product data to sessionStorage
    if (window.buyingOptionsData) {
      this.storeBuyingOptions(window.buyingOptionsData);
    }

    this.getSelectedTyreData();
    const template = document.getElementById('buying-options-template')?.innerHTML;
    if (template) {
      this.loadBuyingOptions();
      if (this.buyingOptions && this.foundSizes.length > 0) {
        const insertEl = document.querySelector('main') || document.body;

        insertEl.insertAdjacentHTML('afterend', Mustache.render(template, this.buyingOptions));
      }
    }
    else {
      this.updateFoundSizes();
    }

    // End if missing buying options DOM element (not included on the page) or missing tyre data (nothing is chosen) or selected size is not found
    if (!document.querySelector('.buying-options-bar') || !this.tyreData || !this.selectedSize || !this.foundSizes.length) {
      return
    }

    // Get html elements

    this.buyingOptionsBar = document.querySelector('.buying-options-bar');
    this.buyingOptionsPopover = this.buyingOptionsBar?.querySelector('.buying-options-bar__pop-over') || null;
    this.buyingOptionsVehicle = this.buyingOptionsPopover?.querySelector('[data-buying-options-vehicle]') || null;
    this.buyingOptionsTyreSize = this.buyingOptionsPopover?.querySelector('[data-buying-options-tyre-size]') || null;
    this.buyingOptionsToggler = document.querySelector('[data-buying-options-toggler]');
    this.buyingOptionsIconToggler = document.querySelector('[data-buying-options-icon-toggler]');
    this.tyreOptionsContainer = this.buyingOptionsBar?.querySelector('[data-tyre-options]') || null;
    this.tyreselectorLink = this.buyingOptionsBar?.querySelector('[data-buying-options-tyreselector-link]') || null;
    this.buyingOptionsOpen = this.buyingOptionsToggler?.textContent || '';
    this.buyingOptionsClose = this.buyingOptionsBar?.getAttribute('data-buying-options-close') || '';

    //this.tyreOptionsTemplate = this.buyingOptionsBar.querySelector('[data-template="tyre-options"]').textContent;

    // Set event listeners

    // Buying options pop-over togglers click event listeners
    this.buyingOptionsToggler?.addEventListener('click', function (e) {
      self.toggleBuyingOptions(null, true);
    });

    // Icon button in modal, separate event
    this.buyingOptionsIconToggler?.addEventListener('click', function () {
      self.toggleBuyingOptions(null, true);
    });

    // Prevent link from loading if tyre selector locates on same page
    this.tyreselectorLink?.addEventListener('click', function (evt) {
      evt.preventDefault();
      self.sendAnalyticsEvent('quickBuyChange');

      // Load group page after small delay
      if (!self.scrollToTyreselector()) {
        setTimeout(() => {
          if (self.tyreselectorLink) window.location = self.tyreselectorLink.getAttribute('href') as unknown as Location;
        }, 500);
      }
    });

    document.addEventListener('keydown', this.onDocumentKeyDown.bind(this));

    // Set popover texts and button actions
    this.updatePopoverContentAndActions();

    // Automatically hide $buyingOptionsBar when footer is reached and show it again when footer is off screen

/*     let documentFooter = document.querySelector('.footer');

    // Create intersection observer
    const footerObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (self.buyingOptionsBar) self.buyingOptionsBar.style.display = 'none';
          self.toggleBuyingOptions(false);
        } else {
          if (self.buyingOptionsBar) self.buyingOptionsBar.style.display = 'flex';
        }
      });
    }, {
      rootMargin: '0px 0px 0px 0px',
      threshold: 0.2
    });

    if (documentFooter) {
      // show options bar
      if (this.buyingOptionsBar) this.buyingOptionsBar.style.display = 'none';
      // Add intersection observer for document footer
      footerObserver.observe(documentFooter);
    } */

    if (this.buyingOptionsBar) this.buyingOptionsBar.style.display = 'flex';
    if (this.buyingOptionsToggler) this.buyingOptionsToggler.style.display = 'flex';

    // Open buying options popover on page load IF user has not closed it before OR we are on product page
    if (window.innerWidth >= 768) {
      // Only 768+ screens
      if (document.body.classList.contains('open-buying-options') || (storage.local && localStorage.getItem('buyingOtionsOnceClosed') !== 'true')) {
        self.toggleBuyingOptions(true);
      }
    }

  } // init()

};

interface BuyingOptionsBar {
  buyingOptions: any;
  tyreData: TyreData | null;
  selectedSize: any;
  selectedVehicle: any;
  foundSizes: any[];
  buyingOptionsBar: HTMLElement | null;
  buyingOptionsPopover: HTMLElement | null;
  buyingOptionsVehicle: HTMLElement | null;
  buyingOptionsTyreSize: HTMLElement | null;
  buyingOptionsToggler: HTMLElement | null;
  buyingOptionsIconToggler: HTMLElement | null;
  tyreOptionsContainer: HTMLElement | null;
  tyreOptionsTemplate: string;
  tyreselectorLink: HTMLElement | null;
  buyingOptionsOpen: string;
  buyingOptionsClose: string;
  sendAnalyticsEvent: (type: string, data?: any) => void;
  toggleBuyingOptions: (show: boolean | null, sendEvent?: boolean) => boolean;
  updatePopoverContentAndActions: () => void;
  storeBuyingOptions: (data: any) => void;
  loadBuyingOptions: () => void;
  getSelectedTyreData: () => void;
  updateFoundSizes: () => void;
  scrollToTyreselector: () => boolean;
  onDocumentKeyDown: (event: KeyboardEvent) => void;
  init: () => void;
}

interface TyreData {
  width: number;
  height: number;
  rim: number;
  tsViewNavItem: string;
  tsViews: string;
  manufacturer?: {
    text: string;
    value: string;
  };
  model?: {
    text: string;
    value: string;
  };
  vehicle?: {
    text: string;
    value: string;
  }
  year?: {
    text: string;
    value: string;
  };
  license?: {
    text: string;
    data: {
      id: string;
      manufacturer: string;
      model: string;
      year: string;
      kw: string;
      hp: string;
      tyres: any;
      wheels: any;
      pcd: string;
      offset: string;
      center_bore: string;
      sorted: string[];
    };
  }
}

declare global {
  interface Window {
    dataLayer: any[];
    buyingOptionsData: any;
    buyingOptionsTyreSizes: Array<{
      code: string;
      height: number;
      loadIndex: number;
      productInfo: string;
      rim: number;
      speedRating: string;
      width: number;
    }>;
  }
}

export default buyingOptionsBar;
